var map = {
	"./descriptions": 154,
	"./descriptions.json": 154,
	"./icons/All.png": 4032,
	"./icons/Alternative.png": 7764,
	"./icons/Classic_Rock.png": 9685,
	"./icons/Classical.png": 5786,
	"./icons/Country.png": 5731,
	"./icons/Dance.png": 2436,
	"./icons/Electronic.png": 9251,
	"./icons/Folk.png": 6103,
	"./icons/From_Other_Entertainment.png": 6545,
	"./icons/Half_a_Day_of_Songs_I_enjoy.png": 2702,
	"./icons/Hard_Rock.png": 2940,
	"./icons/Heavy_Metal.png": 1984,
	"./icons/Oldies.png": 6589,
	"./icons/Pop.png": 7536,
	"./icons/Punk.png": 7253,
	"./icons/Rap__slash__Hip_Hop.png": 4650,
	"./icons/Rhythm_and_Blues.png": 2761,
	"./icons/Rock.png": 2434,
	"./icons/source/All.svg": 6888,
	"./icons/source/Alternative.svg": 5383,
	"./icons/source/Classic_Rock.svg": 7027,
	"./icons/source/Classical.svg": 7838,
	"./icons/source/Country.svg": 7119,
	"./icons/source/Dance.svg": 3752,
	"./icons/source/Default.svg": 5790,
	"./icons/source/Electronic.svg": 353,
	"./icons/source/Folk.svg": 8549,
	"./icons/source/From_Other_Entertainment.svg": 491,
	"./icons/source/Half_a_Day_of_Songs_I_enjoy.svg": 522,
	"./icons/source/Hard_Rock.svg": 1916,
	"./icons/source/Heavy_Metal.svg": 7712,
	"./icons/source/Oldies.svg": 4535,
	"./icons/source/Pop.svg": 6172,
	"./icons/source/Punk.svg": 5207,
	"./icons/source/Rap__slash__Hip_Hop.svg": 6318,
	"./icons/source/Rhythm_and_Blues.svg": 6791,
	"./icons/source/Rock.svg": 3016,
	"./origin": 6855,
	"./origin.json": 6855,
	"./playlistSrcs": 2676,
	"./playlistSrcs.json": 2676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3958;